import React from "react";
import { useSelector } from "react-redux";
import { selectors } from "@ReduxStore/reducers";
import { Analytics } from "@accessdev/arc-ui-react";
import { getCookie } from "@Src/utils/cookie.utils";
import {
  VWO_NAV_COOKIE,
  VWO_SEARCH_COOKIE,
  VWO_NAV_COOKIE_VALUE_OPT_1,
  VWO_NAV_COOKIE_VALUE_OPT_2,
  VWO_SEARCH_COOKIE_VALUE_OPT_1,
  VWO_SEARCH_COOKIE_VALUE_OPT_2,
} from "@Src/constants";

function AddOns() {
  const member = useSelector(selectors.getAddOnsMemberAccountInfo);
  const program = useSelector(selectors.getAddOnsProgramInfo);
  const domains = useSelector(selectors.getProgramDomains);
  const allowedEnvs = ["stage", "production"];
  const env = process.env.REACT_APP_ENV || "development";
  const navigationTest = getCookie(VWO_NAV_COOKIE);
  const searchLocationTest = getCookie(VWO_SEARCH_COOKIE);
  const navigationTestValue = [VWO_NAV_COOKIE_VALUE_OPT_1, VWO_NAV_COOKIE_VALUE_OPT_2].includes(
    navigationTest,
  )
    ? navigationTest
    : "none";

  const searchLocationTestValue = [
    VWO_SEARCH_COOKIE_VALUE_OPT_1,
    VWO_SEARCH_COOKIE_VALUE_OPT_2,
  ].includes(searchLocationTest)
    ? searchLocationTest
    : "none";

  const customProperties = {
    ab_navigationTest: navigationTestValue,
    ab_searchLocationTest: searchLocationTestValue,
  };

  if (allowedEnvs.includes(env)) {
    const supportedDomains = [domains.app, domains.travel.replace("https://", "")];
    return (
      <Analytics
        program={program}
        member={member}
        domains={supportedDomains}
        customProperties={customProperties}
      />
    );
  }
  return null;
}

export default AddOns;
